import { __assign, __read } from "tslib";
import React, { useRef, useState } from "react";
import { useTheme } from "@material-ui/core";
import { CommentSend, HelperText, PostCommentContainer, TextField } from "./style";
var PostComment = function (_a) {
    var lessonId = _a.lessonId, parentId = _a.parentId, placeholder = _a.placeholder, defaultValue = _a.defaultValue, onEditClose = _a.onEditClose, edit = _a.edit, commentId = _a.commentId, onMockDelete = _a.onMockDelete, onCreate = _a.onCreate, onEdit = _a.onEdit;
    var theme = useTheme();
    var textAreaRef = useRef(null);
    var _b = __read(useState(false), 2), commentLimit = _b[0], setCommentLimit = _b[1];
    var resetPostCommentField = function () {
        textAreaRef.current.value = "";
    };
    var postComment = function () {
        setCommentLimit(false);
        if (textAreaRef.current.value.trim().length !== 0) {
            if (edit && onEditClose) {
                onMockDelete(parentId, commentId, textAreaRef.current.value);
                onEdit(textAreaRef.current.value, lessonId, parentId, commentId);
                resetPostCommentField();
                onEditClose();
                return;
            }
            onCreate(textAreaRef.current.value, lessonId, parentId);
            resetPostCommentField();
        }
    };
    var onChangeText = function (e) {
        if (e.target.value.length > 600) {
            var value = e.target.value;
            value = value.substring(0, 600);
            textAreaRef.current.value = value;
            setCommentLimit(true);
        }
        else if (commentLimit) {
            setCommentLimit(false);
        }
    };
    return (React.createElement(PostCommentContainer, null,
        React.createElement(TextField, __assign({ isEditing: edit }, (commentLimit && {
            helperText: React.createElement(HelperText, null, " You have reached the maximum text limit. ")
        }), { autoFocus: true, fullWidth: true, hiddenLabel: true, multiline: true, inputRef: textAreaRef, InputProps: {
                style: {
                    color: theme.palette.text.primary,
                    height: "100%",
                    paddingTop: "10px",
                    backgroundColor: theme.palette.background.default
                },
                disableUnderline: true
            }, defaultValue: defaultValue, color: "primary", onChange: onChangeText, onKeyPress: function (event) {
                if (event.key === "Enter" && !event.shiftKey) {
                    event.preventDefault();
                    postComment();
                }
            }, variant: "filled", size: "small", placeholder: placeholder || "Write a comment..." })),
        React.createElement(CommentSend, { isEditing: edit, onClick: postComment },
            React.createElement("span", null, edit ? "Save Changes" : "Send"))));
};
export default PostComment;
//# sourceMappingURL=PostComment.js.map